export const STORE_APPLICATION_DEFINITION_CONDITIONAL_EDIT = 'applicationDefinitionConditionalEditUI';
export type STORE_APPLICATION_DEFINITION_CONDITIONAL_EDIT = typeof STORE_APPLICATION_DEFINITION_CONDITIONAL_EDIT;

export const STORE_APPLICATION_DEFINITION_CONDITIONAL_BINDING_PREVIEW =
    'applicationDefinitionConditionalBindingPreviewUI';
export type STORE_APPLICATION_DEFINITION_CONDITIONAL_BINDING_PREVIEW =
    typeof STORE_APPLICATION_DEFINITION_CONDITIONAL_BINDING_PREVIEW;
